import { connect } from 'react-redux'
import React from 'react'
import { cx } from 'emotion'
import styled from 'react-emotion'
import { themeGet as th } from 'styled-system'

import {
  doOpenReplyDirectPage,
  doOpenTicketPage,
  doOpenForwardPage,
  doShowReplyHeaderRow,
} from 'actions/pages'

import { selectIsReplyHeaderExpanded } from 'selectors/page'
import { selectCurrentPageWithCollapsedHeaderAction } from 'selectors/location'
import { selectRecipients } from 'ducks/drafts'
import {
  selectOpenTicketPageAction,
  selectOpenReplyDirectPageAction,
  selectOpenForwardPageAction,
} from 'selectors/pageActions'
import { Flex } from 'shared/ui'

import debug from 'util/debug'
import { stopEvent } from 'util/keys'
import { isForwarding, isReplyingAll } from 'util/draft'

import Expanded from 'components/App/DesktopView/shared/Composer/Header/Expanded'
import FormSwitcherButton from '../../shared/FormSwitcherButton'

const select = state => ({
  isExpanded: selectIsReplyHeaderExpanded(state),
  recipients: selectRecipients(state),
  // small perf improvement that avoids creating new object refs all the time
  replyTo: selectOpenTicketPageAction(state),
  replyDirectTo: selectOpenReplyDirectPageAction(state),
  forwardTo: selectOpenForwardPageAction(state),
  currentTicketActionWithCollapsedHeader: selectCurrentPageWithCollapsedHeaderAction(
    state
  ),
})

const clickHandler = draftType => {
  if (isForwarding(draftType)) return doOpenForwardPage
  if (isReplyingAll(draftType)) return doOpenTicketPage
  return doOpenReplyDirectPage
}

// note - we can't use a performFactory fn here as ownProps changes.
const perform = dispatch => {
  return {
    onActionClick: (draftType, ticketId, showField, evt) => {
      stopEvent(evt)
      dispatch(
        doShowReplyHeaderRow(clickHandler(draftType), ticketId, showField)
      )
    },
    onClick: (draftType, ticketId) =>
      dispatch(clickHandler(draftType)(ticketId, { expand: true })),
  }
}

class Header extends React.PureComponent {
  componentWillReceiveProps(nextProps) {
    if (nextProps.isExpanded === this.props.isExpanded) return false
    if (!nextProps.isExpanded && !this.props.isExpanded) return false
    return this.emitToggleEvent()
  }

  emitToggleEvent = () => {
    debug('replyHeaderToggled')
    window.dispatchEvent(new CustomEvent('replyHeaderToggled'))
  }

  render() {
    const {
      className,
      isExpanded,
      replyTo, // dont passthru
      replyDirectTo, // dont passthru
      forwardTo, // dont passthru
      currentTicketActionWithCollapsedHeader,
      ...props
    } = this.props
    if (!isExpanded) return null
    const forwarding = isForwarding(props.draftType)
    return (
      <Flex flex="0 0 auto" className={cx('header', className)}>
        <Expanded closeTo={currentTicketActionWithCollapsedHeader} {...props}>
          {!forwarding && (
            <FormSwitcherButton
              key={props.ticketId}
              ticketId={props.ticketId}
            />
          )}
        </Expanded>
      </Flex>
    )
  }
}

// The header wrapper is here to prevent re-rendering with functions get rebuilt
// eslint-disable-next-line react/no-multi-comp
class HeaderWrapper extends React.PureComponent {
  onClick = () => {
    const { draftType, ticketId } = this.props
    this.props.onClick(draftType, ticketId)
  }

  onActionClick = (showField, evt) => {
    const { draftType, ticketId } = this.props
    this.props.onActionClick(draftType, ticketId, showField, evt)
  }

  onSubjectChange = (...args) => {
    this.props.onSubjectChange(...args)
  }

  onMailboxClick = (...args) => {
    this.props.onMailboxClick(...args)
  }

  render() {
    const {
      onClick,
      onActionClick,
      onMailboxClick,
      onSubjectChange,
      ...rest
    } = this.props
    return (
      <Header
        onClick={this.onClick}
        onActionClick={this.onActionClick}
        onSubjectChange={this.onSubjectChange}
        onMailboxClick={this.onMailboxClick}
        recipientsOpenUpward
        {...rest}
      />
    )
  }
}

export default connect(select, perform)(styled(HeaderWrapper)`
  background-color: ${th('colors.brightSuperDark')};
  border-bottom: 1px solid ${th('colors.ultraDust')};
  border-top: 1px solid ${th('colors.ultraDust')};
  margin: 0 -16px ${th('space.2')}px;
  padding: 6px ${th('space.3')}px 4px;
`)
